import { render, staticRenderFns } from "./StockIndex.vue?vue&type=template&id=4be5a15f"
import script from "./StockIndex.vue?vue&type=script&lang=js"
export * from "./StockIndex.vue?vue&type=script&lang=js"
import style0 from "./StockIndex.vue?vue&type=style&index=0&id=4be5a15f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports